module.exports = "https://cdn.realtymogul.com/static/media/loader-white.44a375be.svg";